import { Component, Input, OnInit, inject, input } from '@angular/core';
import { JkBaseComponent, } from 'jk-service';
import { idNameItem, newOpenwinLoadOption } from 'jk-service';
import { MaterialModule } from 'jk-service';
import { StkmbService } from '../../_service_stk';
import { JackBaseComponentModule } from 'jk-service';
import { JkgridwinComponent } from 'jk-advcom';

@Component({
  selector: 'app-future-stock',
  standalone: true,
  imports: [
    MaterialModule,
    JkgridwinComponent,
    JackBaseComponentModule,
  ],
  templateUrl: './future-stock.component.html',
  styleUrl: './future-stock.component.css'
})
export class FutureStockComponent extends JkBaseComponent implements OnInit {
  stkmbSrv = inject(StkmbService);

  // 未平倉
  stkmrGrid!: JkgridwinComponent;
  _account: string = 'F0200008728692';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get account(): string {
    return this._account;
  }
  set account(value: string) {
    this._account = value;
    this.doQuery();
  }
  readonly accountList = input<idNameItem[]>([]);
  readonly userId = input<string>('');
  override ngOnInit() {
    super.ngOnInit();
    if (this.orm) {
      let n = newOpenwinLoadOption('STKMR', '002', 'S', [], this.accountList());
      this.openwinLoadOpts.push(n);
      this.orm.loadOpenwinOptions(this.openwinLoadOpts);
    }
  }
  override ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => {
      if (this.stkmbSrv.futureAccountList.length > 0)
        this.account = this.stkmbSrv.seaAccountList[0].id;
      this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
    }, 1000);
  }

  afterGridReady($event: JkgridwinComponent) {
    this.stkmrGrid = $event;
    this.doQuery();
  }
  doQuery() {
    if (!this.account) return;
    let where = ` AND MR002='${this.account}'`;
    this.stkmrGrid.doQuery2('STKMR', '001', 'S', where);
  }
}
